export default __webpack_public_path__ + "static/media/simply-hunting-experience-1.8b1f0e33.jpg";